import footer from '../styles/styles.module.scss'


export default function
Footer() {

 
  return (
    <div className={footer.footer} >
        
        
         <h2 className={footer.copyright}  > © 2023 by Jordan Jacoby</h2>
           
       
    </div>
  )
}
